import axios from 'axios';
import { attachAuthInterceptor } from './authInterceptor';
import { API_BASE_URL } from '../utils/constants';
import { getAuthToken } from '../utils/storage';
import { extractApiError } from '../utils/apiError';

import { applyWarehouseFilter, warehouseParamsSerializer } from '../utils/warehouseParams';

const supervisorAnalyticsAPI = axios.create({
    baseURL: `${API_BASE_URL}/api/v1/supervisor-analytics`,
    headers: { 'Content-Type': 'application/json' },
    paramsSerializer: warehouseParamsSerializer,
});

// Session-expiry handling (401 -> clear + redirect), consistent with feature services.
attachAuthInterceptor(supervisorAnalyticsAPI);

supervisorAnalyticsAPI.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return applyWarehouseFilter(config);
    },
    (error) => Promise.reject(error)
);

const supervisorAnalyticsService = {
    async getSummary(params = {}) {
        try {
            const response = await supervisorAnalyticsAPI.get('/summary', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async getLoading(params = {}, options = {}) {
        try {
            const response = await supervisorAnalyticsAPI.get('/loading', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    async getUnloading(params = {}, options = {}) {
        try {
            const response = await supervisorAnalyticsAPI.get('/unloading', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    async getLeaderboard(params = {}) {
        try {
            const response = await supervisorAnalyticsAPI.get('/leaderboard', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },
};

export default supervisorAnalyticsService;
